import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 7a5 5 0 0 1 5 -5a5 5 0 0 1 5 5v10a5 5 0 0 1 -5 5a5 5 0 0 1 -5 -5l0 -10","key":"svg-0"}],["path",{"d":"M11 7a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-1"}],["path",{"d":"M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-2"}],["path",{"d":"M11 17a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-3"}]]

const IconTrafficLights = createReactComponent('outline', 'traffic-lights', 'TrafficLights', __iconNode);

export default IconTrafficLights;